/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_No_ItemsInputs */

const en_pwf_no_items = /** @type {(inputs: Pwf_No_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This product has no items yet, so there is nothing to map. The switch only changes which statuses new items can use.`)
};

const de_pwf_no_items = /** @type {(inputs: Pwf_No_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Produkt hat noch keine Vorgänge, es gibt also nichts zuzuordnen. Der Wechsel ändert nur, welche Status neue Vorgänge nutzen können.`)
};

/**
* | output |
* | --- |
* | "This product has no items yet, so there is nothing to map. The switch only changes which statuses new items can use." |
*
* @param {Pwf_No_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_no_items = /** @type {((inputs?: Pwf_No_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_No_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_no_items(inputs)
	return en_pwf_no_items(inputs)
});